import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import Header from "../Header";
import Sidebar from "../Sidebar";
import Footer from "../Footer";
import CampaignHeader from "./CampaignHeader";
import { notifyError } from "../../helper";
import client from "../../api";
import DataLoader from "../DataLoader";
import SequenceMessagePreview from "./SequenceMessagePreview";


const CampaignSequence = () => {
    const {campaignID} = useParams('');
    const api = client();
    const [messagesData,setMessageData] = useState({});
    useEffect(()=>{
        const getAllSteps = async () => {
            try{
                const response = await api.post('/v1/campaign/steps/all',{campaignID:campaignID});
                if(response.status === 200 || response.status === 201){
                    const data = response.data.data;
                    setMessageData(data);                    
                }
            } catch(error) {
                console.log('error.message',error);
                if(error.status === 400) notifyError('Bad Request. Unable to fetch composed messaged steps. Please try again');
            }
        }
        getAllSteps();
    },[]);

    return(<>
    
        <Header/>
        <div className="main-page">
            <Sidebar/>
            <div className="campaign-pages-wrap">
                <CampaignHeader page={'sequence'}/>
                <div className="campaign-sequence-wrap">
                    {Object.keys(messagesData).length ? <div className="campaign-sequence">
                        <div className="sequence-block-1">
                            <Link to={`/campaign/${campaignID}/edit-sequence`} className="edit-action">Edit Sequence</Link>
                        </div>
                        <div className="sequence-block-2">
                            <div className="sequence-steps">
                                {(messagesData.steps).length && (messagesData.steps).map((step,i)=>(<SequenceMessagePreview key={i} index={i} step={step} messageType={messagesData?.message_mime_type} />))}
                            </div>
                        </div>
                    </div>:<DataLoader/>}
                </div>
            </div>
        </div>
        <Footer/>
        </>);
}

export default CampaignSequence;